var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('ace-editor',{ref:"xmleditor",attrs:{"editor-id":"xmleditor","content":_vm.content,"lang":'xml',"theme":'terminal',"height":500}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }